import { default as index3pzEZ2SMLOMeta } from "/home/runner/work/srov-investor-app/srov-investor-app/pages/auth/forgotten-password/index.vue?macro=true";
import { default as success_45resetSOd3yLgvbeMeta } from "/home/runner/work/srov-investor-app/srov-investor-app/pages/auth/forgotten-password/success-reset.vue?macro=true";
import { default as successwvVY9OErJyMeta } from "/home/runner/work/srov-investor-app/srov-investor-app/pages/auth/forgotten-password/success.vue?macro=true";
import { default as loginVtzESlCBo5Meta } from "/home/runner/work/srov-investor-app/srov-investor-app/pages/auth/login.vue?macro=true";
import { default as confirmMDp55TGM6YMeta } from "/home/runner/work/srov-investor-app/srov-investor-app/pages/auth/register/confirm.vue?macro=true";
import { default as indexyL5EPKHsu1Meta } from "/home/runner/work/srov-investor-app/srov-investor-app/pages/auth/register/index.vue?macro=true";
import { default as passwordBzQyxli1d7Meta } from "/home/runner/work/srov-investor-app/srov-investor-app/pages/auth/register/password.vue?macro=true";
import { default as successR5opIWE2D2Meta } from "/home/runner/work/srov-investor-app/srov-investor-app/pages/auth/register/success.vue?macro=true";
import { default as reset_45password6dTYAHre8HMeta } from "/home/runner/work/srov-investor-app/srov-investor-app/pages/auth/reset-password.vue?macro=true";
import { default as indexrpHbKJScSnMeta } from "/home/runner/work/srov-investor-app/srov-investor-app/pages/index.vue?macro=true";
import { default as _91id_93LFO0x6Tfe6Meta } from "/home/runner/work/srov-investor-app/srov-investor-app/pages/orders/create/base/[id].vue?macro=true";
import { default as indexgMtN2Piy7mMeta } from "/home/runner/work/srov-investor-app/srov-investor-app/pages/orders/create/index.vue?macro=true";
import { default as _91id_93ejQCxClo5kMeta } from "/home/runner/work/srov-investor-app/srov-investor-app/pages/orders/create/parameters/[id].vue?macro=true";
import { default as successbLVAKuMH4kMeta } from "/home/runner/work/srov-investor-app/srov-investor-app/pages/orders/create/success.vue?macro=true";
import { default as indexOWOx1QS9aSMeta } from "/home/runner/work/srov-investor-app/srov-investor-app/pages/orders/sync/consent/index.vue?macro=true";
import { default as indexMTyTvIDWFQMeta } from "/home/runner/work/srov-investor-app/srov-investor-app/pages/orders/sync/index.vue?macro=true";
import { default as indexO3LkfqEzdaMeta } from "/home/runner/work/srov-investor-app/srov-investor-app/pages/orders/sync/settings/index.vue?macro=true";
import { default as successH5eZtsbYnpMeta } from "/home/runner/work/srov-investor-app/srov-investor-app/pages/orders/sync/settings/success.vue?macro=true";
import { default as successCp91sPAqWwMeta } from "/home/runner/work/srov-investor-app/srov-investor-app/pages/orders/sync/success.vue?macro=true";
import { default as indexcz3Io3OhS1Meta } from "/home/runner/work/srov-investor-app/srov-investor-app/pages/portfolio/[id]/index.vue?macro=true";
import { default as indexKKORP1sqqlMeta } from "/home/runner/work/srov-investor-app/srov-investor-app/pages/portfolio/[id]/management/index.vue?macro=true";
import { default as index7BwhMC1s5KMeta } from "/home/runner/work/srov-investor-app/srov-investor-app/pages/portfolio/index.vue?macro=true";
import { default as portfoliokT8y7SS4VvMeta } from "/home/runner/work/srov-investor-app/srov-investor-app/pages/portfolio.vue?macro=true";
import { default as _91isin_939CaPRLAsTmMeta } from "/home/runner/work/srov-investor-app/srov-investor-app/pages/returns/[isin].vue?macro=true";
import { default as indexoIy38id0cOMeta } from "/home/runner/work/srov-investor-app/srov-investor-app/pages/returns/index.vue?macro=true";
import { default as settings0uaEUQiYnnMeta } from "/home/runner/work/srov-investor-app/srov-investor-app/pages/settings.vue?macro=true";
export default [
  {
    name: "auth-forgotten-password___cs",
    path: "/auth/forgotten-password",
    meta: index3pzEZ2SMLOMeta || {},
    component: () => import("/home/runner/work/srov-investor-app/srov-investor-app/pages/auth/forgotten-password/index.vue").then(m => m.default || m)
  },
  {
    name: "auth-forgotten-password-success-reset___cs",
    path: "/auth/forgotten-password/success-reset",
    meta: success_45resetSOd3yLgvbeMeta || {},
    component: () => import("/home/runner/work/srov-investor-app/srov-investor-app/pages/auth/forgotten-password/success-reset.vue").then(m => m.default || m)
  },
  {
    name: "auth-forgotten-password-success___cs",
    path: "/auth/forgotten-password/success",
    meta: successwvVY9OErJyMeta || {},
    component: () => import("/home/runner/work/srov-investor-app/srov-investor-app/pages/auth/forgotten-password/success.vue").then(m => m.default || m)
  },
  {
    name: "auth-login___cs",
    path: "/auth/login",
    meta: loginVtzESlCBo5Meta || {},
    component: () => import("/home/runner/work/srov-investor-app/srov-investor-app/pages/auth/login.vue").then(m => m.default || m)
  },
  {
    name: "auth-register-confirm___cs",
    path: "/auth/register/confirm",
    meta: confirmMDp55TGM6YMeta || {},
    component: () => import("/home/runner/work/srov-investor-app/srov-investor-app/pages/auth/register/confirm.vue").then(m => m.default || m)
  },
  {
    name: "auth-register___cs",
    path: "/auth/register",
    meta: indexyL5EPKHsu1Meta || {},
    component: () => import("/home/runner/work/srov-investor-app/srov-investor-app/pages/auth/register/index.vue").then(m => m.default || m)
  },
  {
    name: "auth-register-password___cs",
    path: "/auth/register/password",
    meta: passwordBzQyxli1d7Meta || {},
    component: () => import("/home/runner/work/srov-investor-app/srov-investor-app/pages/auth/register/password.vue").then(m => m.default || m)
  },
  {
    name: "auth-register-success___cs",
    path: "/auth/register/success",
    meta: successR5opIWE2D2Meta || {},
    component: () => import("/home/runner/work/srov-investor-app/srov-investor-app/pages/auth/register/success.vue").then(m => m.default || m)
  },
  {
    name: "auth-reset-password___cs",
    path: "/auth/reset-password",
    meta: reset_45password6dTYAHre8HMeta || {},
    component: () => import("/home/runner/work/srov-investor-app/srov-investor-app/pages/auth/reset-password.vue").then(m => m.default || m)
  },
  {
    name: "index___cs",
    path: "/",
    component: () => import("/home/runner/work/srov-investor-app/srov-investor-app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "orders-create-base-id___cs",
    path: "/orders/create/base/:id()",
    meta: _91id_93LFO0x6Tfe6Meta || {},
    component: () => import("/home/runner/work/srov-investor-app/srov-investor-app/pages/orders/create/base/[id].vue").then(m => m.default || m)
  },
  {
    name: "orders-create___cs",
    path: "/orders/create",
    meta: indexgMtN2Piy7mMeta || {},
    component: () => import("/home/runner/work/srov-investor-app/srov-investor-app/pages/orders/create/index.vue").then(m => m.default || m)
  },
  {
    name: "orders-create-parameters-id___cs",
    path: "/orders/create/parameters/:id()",
    meta: _91id_93ejQCxClo5kMeta || {},
    component: () => import("/home/runner/work/srov-investor-app/srov-investor-app/pages/orders/create/parameters/[id].vue").then(m => m.default || m)
  },
  {
    name: "orders-create-success___cs",
    path: "/orders/create/success",
    meta: successbLVAKuMH4kMeta || {},
    component: () => import("/home/runner/work/srov-investor-app/srov-investor-app/pages/orders/create/success.vue").then(m => m.default || m)
  },
  {
    name: "orders-sync-consent___cs",
    path: "/orders/sync/consent",
    meta: indexOWOx1QS9aSMeta || {},
    component: () => import("/home/runner/work/srov-investor-app/srov-investor-app/pages/orders/sync/consent/index.vue").then(m => m.default || m)
  },
  {
    name: "orders-sync___cs",
    path: "/orders/sync",
    meta: indexMTyTvIDWFQMeta || {},
    component: () => import("/home/runner/work/srov-investor-app/srov-investor-app/pages/orders/sync/index.vue").then(m => m.default || m)
  },
  {
    name: "orders-sync-settings___cs",
    path: "/orders/sync/settings",
    meta: indexO3LkfqEzdaMeta || {},
    component: () => import("/home/runner/work/srov-investor-app/srov-investor-app/pages/orders/sync/settings/index.vue").then(m => m.default || m)
  },
  {
    name: "orders-sync-settings-success___cs",
    path: "/orders/sync/settings/success",
    meta: successH5eZtsbYnpMeta || {},
    component: () => import("/home/runner/work/srov-investor-app/srov-investor-app/pages/orders/sync/settings/success.vue").then(m => m.default || m)
  },
  {
    name: "orders-sync-success___cs",
    path: "/orders/sync/success",
    meta: successCp91sPAqWwMeta || {},
    component: () => import("/home/runner/work/srov-investor-app/srov-investor-app/pages/orders/sync/success.vue").then(m => m.default || m)
  },
  {
    name: portfoliokT8y7SS4VvMeta?.name,
    path: "/portfolio",
    component: () => import("/home/runner/work/srov-investor-app/srov-investor-app/pages/portfolio.vue").then(m => m.default || m),
    children: [
  {
    name: "portfolio-id___cs",
    path: ":id()",
    meta: indexcz3Io3OhS1Meta || {},
    component: () => import("/home/runner/work/srov-investor-app/srov-investor-app/pages/portfolio/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "portfolio-id-management___cs",
    path: ":id()/management",
    meta: indexKKORP1sqqlMeta || {},
    component: () => import("/home/runner/work/srov-investor-app/srov-investor-app/pages/portfolio/[id]/management/index.vue").then(m => m.default || m)
  },
  {
    name: "portfolio___cs",
    path: "",
    meta: index7BwhMC1s5KMeta || {},
    component: () => import("/home/runner/work/srov-investor-app/srov-investor-app/pages/portfolio/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "returns-isin___cs",
    path: "/returns/:isin()",
    meta: _91isin_939CaPRLAsTmMeta || {},
    component: () => import("/home/runner/work/srov-investor-app/srov-investor-app/pages/returns/[isin].vue").then(m => m.default || m)
  },
  {
    name: "returns___cs",
    path: "/returns",
    meta: indexoIy38id0cOMeta || {},
    component: () => import("/home/runner/work/srov-investor-app/srov-investor-app/pages/returns/index.vue").then(m => m.default || m)
  },
  {
    name: "settings___cs",
    path: "/settings",
    meta: settings0uaEUQiYnnMeta || {},
    component: () => import("/home/runner/work/srov-investor-app/srov-investor-app/pages/settings.vue").then(m => m.default || m)
  }
]